import './About.css';

/**
 * 紹介ページ。アプリ共通の Header/Footer（App.tsx でルート全体に表示）に相乗りする
 * 通常ページで、独自のヘッダー/フッターは持たない。
 */
export default function About() {
  return (
    <div className="about-page">
      <section className="about-section about-hero">
        <div className="about-wrap about-hero__inner">
          <h1 className="about-h1">
            推しの
            <br />
            いろんなモーションを
            <br />
            いっぱい見てぇなぁ！！
          </h1>
          <p className="about-lead">
            VRMA Hub は、モーションをみんなで共有して楽しむためのプラットフォームです。あなたの好きなキャラクターをいろんなポーズで遊んでみましょう！
          </p>
        </div>
      </section>

      <section className="about-section about-usecase">
        <div className="about-wrap about-usecase__inner">
          <div className="about-usecase__intro">
            <h2 className="about-h2">様々なユースケースに対応</h2>
            <p className="about-body">
              ちょっとキャラクターを動かして遊びたい人から、ポーズを使ってアプリを作りたい人、ポーズを販売している人など。様々ユーザーのニーズにこたえます。
            </p>
          </div>
          <div className="about-usecase__grid">
            <div className="about-card">
              <div className="about-card__tag">ライトユーザー</div>
              <h3 className="about-card__title">
                キャラクターを
                <br />
                動かしてみたい
              </h3>
              <p className="about-body">
                ブラウザで気になるモーションを選ぶだけで3D
                プレビューが再生されます。好きなVRM アバターを読み込んで動かしてみましょう。
              </p>
            </div>
            <div className="about-card">
              <div className="about-card__tag">エンジニア</div>
              <h3 className="about-card__title">
                ポーズを自分の
                <br />
                アプリで使いたい
              </h3>
              <p className="about-body">
                開発者向け APIで、所持している・公開されているVRMAを取得できます。ゲームや
                VTuber 向けアプリにユーザーのモーションを組み込めます。
              </p>
            </div>
            <div className="about-card">
              <div className="about-card__tag">クリエイター</div>
              <h3 className="about-card__title">
                自分のポーズを
                <br />
                販売している
              </h3>
              <p className="about-body">
                VRMA Hub を作品の紹介ページとして活用できます。自分のアバターで「試してから買える」体験がファンを増やします。
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-section">
        <div className="about-wrap about-features__inner">
          <div className="about-features__intro">
            <h2 className="about-h2">さらに機能を拡張中！</h2>
          </div>
          <div className="about-features__grid">
            <div className="about-feature">
              <h3 className="about-feature__title">Unity から直接アップロード</h3>
              <p className="about-body">
                VCC（VRChat Creator Companion）対応の公式 Unity
                拡張を配布しています。UnityのAnimationClipも簡単にVRMA Hub へ投稿できます。
              </p>
            </div>
            <div className="about-feature">
              <h3 className="about-feature__title">公開範囲を選べる</h3>
              <p className="about-body">
                作品ごとに公開 /
                非公開を作者がコントロールできます。公開した作品は誰でも閲覧でき、連携アプリからダウンロード・利用できます。
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
